<template>
  <div>
    <preloader v-if="loading"  />
    <v-snackbar
      v-model="showSnackbar"
      :timeout="3000"
    >
      {{ snackbarMessage }}
    </v-snackbar>
  </div>
</template>

<script>
import { mapGetters } from "vuex"
import Preloader from "@/components/Preloader.vue"

export default {
  data() {
    return {
      showSnackbar: false
    }
  },
  computed: {
    ...mapGetters(["loading", "snackbar"]),
    snackbarMessage() {
      return this.snackbar? this.snackbar.message : ""
    }
  },
  components: {
    Preloader
  },
  watch: {
    snackbar: {
      handler(val) { 
        if(this.snackbar) { this.showSnackbar = true }
      },
      deep: true
    },
    showSnackbar(val) {
      if(val == false) { this.$store.commit("SET_SNACKBAR", null) }
    }
  }
}
</script>